// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3zqwn","title":"Images45_title__6ztvc","images":"Images45_images__2SEQR"};